

import api from "../api";
import { Loading } from 'element-ui'
const OSS = require('ali-oss');



let loadingInstance = null
function startLoading() {
    loadingInstance = Loading.service({
        fullscreen: true,
        text: '拼命加载中...',
        background: 'rgba(0, 0, 0, 0.8)'
    })
}
function endLoading() {
    loadingInstance.close()
}

const getSecret = () => {
    return new Promise((resolve, reject) => {
        api.oss.getSecret().then(res => {
            resolve(res)
        }).catch(res => {
            reject(res)
        })
    })
}

const readFileAsBuffer = (file) => {
    const reader = new FileReader()
    return new Promise((resolve, reject) => {
        reader.readAsDataURL(file)
        reader.onload = function (e) {
            const base64File = reader.result.replace(/^data:\w+\/\w+;base64,/, '')
            resolve(new OSS.Buffer(base64File, 'base64'))
        }
    })
}
const geturl = (client, storeAs, file) => {
    return new Promise((resolve, reject) => {
        client
            .put(storeAs, file)
            .then(res => {
                resolve(res)
            })
            .catch(res => {
                this.$message({
                    message: '未找到本地文件',
                    type: 'error',
                    duration: 1000
                })
                resolve({ name: '', url: '' })
            })
    })
}
const timestamp = () => {
    var time = new Date()
    var y = time.getFullYear()
    var m = time.getMonth() + 1
    var d = time.getDate()
    var h = time.getHours()
    var mm = time.getMinutes()
    var s = time.getSeconds()
    return {
        y: add0(y),
        m: add0(m),
        d: add0(d),
        h: add0(h),
        mm: add0(mm)
    }
}

const add0 = (m) => {
    return m < 10 ? '0' + m : m
}

export async function uploadoss(obj) {
    let OSSobj = await getSecret()
    OSSobj = OSSobj.data
    let client = new OSS({
        region: 'oss-cn-shanghai',
        accessKeyId: OSSobj.data.accessKeyId,
        accessKeySecret: OSSobj.data.accessKeySecret,
        stsToken: OSSobj.data.accessToken,
        bucket: 'font-factory-test',
        secure: true
    })
    let timestamp1 = new Date().getTime()
    let file = obj.raw //获取文件流
    let url = ''
    let storeAs =
        timestamp().y +
        '/' +
        timestamp().m +
        '/' +
        timestamp().d +
        '/' +
        timestamp().h +
        '/' +
        timestamp().mm +
        '/' +
        timestamp1 +
        '-' +
        obj.raw.name

    console.log(file, storeAs)
    let res = await geturl(client, storeAs, file)
    return res
}